import Cookies from "js-cookie";
import { ACCESS_TOKEN } from "../constants/global";

export const getAccessToken = (): string | undefined =>
  Cookies.get(ACCESS_TOKEN);
